import {roleSystemRoute} from './route_utilities'

import Certificatetypes from '../../views/certificatetypes/Certificatetypes.vue'
import Certificatetype from '../../views/certificatetypes/Certificatetype.vue'
import CertificatetypeGeneral from '../../views/certificatetypes/CertificatetypeGeneral.vue'
import CertificatetypeSuppliers from '../../views/certificatetypes/CertificatetypeSuppliers.vue'
import CreateCertificateType from '../../views/certificatetypes/CreateCertificateType.vue'
import CertificatetypeTranslations from '../../views/certificatetypes/CertificatetypeTranslations.vue'

export const certificatetypes = {
      path: 'certificatetypes',
      name: 'Certificatetypes',
      component: Certificatetypes,
      meta: {
          title: "sertifika_tipleri",
          domain:"certificatetypes",
          accessroles:["admin","brand","auditor","planner"],
        },
      }


export const certificatetype =  {
      path: 'certificatetype/:id',
      name: 'Certificatetype',
      component: Certificatetype,
      redirect: { name: 'CertificatetypeGeneral' },
      meta: {
          title: "sertifika_tipi",
          domain:"certificatetypes",
          accessroles:["admin","brand","auditor","planner"],
        },
        children:[
         {
          path: 'general',
          name: 'CertificatetypeGeneral',
          component: CertificatetypeGeneral,
          meta: {
              title: "sertifika_tipi",
              domain:"certificatetypes"
            },
          },
          {
          path: 'suppliers',
          name: 'CertificatetypeSuppliers',
          component: CertificatetypeSuppliers,
          meta: {
              title: "sertifika_tipi",
              domain:"certificatetypes"
            },
          },          
          {
          path: 'translations',  
          name: 'CertificatetypeTranslations',
          component: CertificatetypeTranslations,
          meta: {
              title: "ceviriler",
              preloader:true,
              domain:"certificatetypes"
            },
          },


        ]        
      }

export const create_certificatetype ={
      path: 'certificatetype',
      name: 'CreateCertificateType',
      component: CreateCertificateType,
      meta: {
          title: "Yeni Sertifika Tipi",
          domain:"certificatetypes"
        },
      }